export function isValidNumber(value: any): boolean {
  switch (typeof value) {
    case 'number':
      return !!value || value === 0
    case 'string':
      const numberValue = Number(value)
      return !!numberValue || numberValue === 0
  }
  return false
}
